/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_List_Aria_LabelInputs */

const en_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available speakers`)
};

const fr_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervenants disponibles`)
};

const de_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Lautsprecher`)
};

const it_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altoparlanti disponibili`)
};

const ru_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступные колонки`)
};

const es_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altavoces disponibles`)
};

const zh_cn2_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲嘉宾`)
};

const ja_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なスピーカー`)
};

const hi_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्ध वक्ता`)
};

const pt_pt2_speakers_list_aria_label = /** @type {(inputs: Speakers_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto-falantes disponíveis`)
};

/**
* | output |
* | --- |
* | "Available speakers" |
*
* @param {Speakers_List_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_list_aria_label = /** @type {((inputs?: Speakers_List_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_List_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_list_aria_label(inputs)
	if (locale === "de") return de_speakers_list_aria_label(inputs)
	if (locale === "it") return it_speakers_list_aria_label(inputs)
	if (locale === "ru") return ru_speakers_list_aria_label(inputs)
	if (locale === "es") return es_speakers_list_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_list_aria_label(inputs)
	if (locale === "ja") return ja_speakers_list_aria_label(inputs)
	if (locale === "hi") return hi_speakers_list_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_list_aria_label(inputs)
	return en_speakers_list_aria_label(inputs)
});